import React, { useEffect } from "react";
import { getAllPackages } from "../../firebase/queries";
import { useDispatch, useSelector } from "react-redux";
import {
  addPackages,
  setSelectedPackages,
} from "../../features/Packages/store/packagesSlice";
import { Select } from "antd";

const PackagesFilter = () => {
  const packages = useSelector((state) => state.packages.packages);
  const selectedPackages = useSelector(
    (state) => state.packages.selectedPackages
  );
  const dispatch = useDispatch();

  const AllOption = {
    label: "All",
    value: "all",
  };

  const options = [
    AllOption,
    ...packages?.map((item) => {
      return {
        label: item?.name,
        value: item?.product_id,
      };
    }),
  ];

  const getPackages = async () => {
    try {
      let response = await getAllPackages();
      dispatch(addPackages(response));
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    if (packages.length === 0) {
      getPackages();
    }
  }, [packages]);

  const handlePackageChange = (id) => {
    if (id.includes("all")) {
      const allSelected = selectedPackages.length === packages.length;
      if (allSelected) {
        dispatch(setSelectedPackages([]));
      } else {
        dispatch(
          setSelectedPackages(packages?.map((item) => item?.product_id))
        );
      }
    } else {
      dispatch(setSelectedPackages(id));
    }
  };

  return (
    <Select
      maxTagCount="responsive"
      mode="multiple"
      allowClear
      style={{
        width: "100%",
      }}
      placeholder="Please select"
      defaultValue={[selectedPackages[0]?.prod_id]}
      value={selectedPackages}
      onChange={handlePackageChange}
      options={options}
    />
  );
};

export default React.memo(PackagesFilter);
